<template>
  <div class="my-3">
    <v-container>
      <div>
        <swiper  v-if="sponsors.length>0" :options="swiperOption">
          <swiper-slide v-for="(slide, index) in sponsors" :key="'sponsor'+index">
            <a :href="slide.link" target="_blank" class="partners--link">
              <img :src="api+slide.image" :alt="slide.description">
            </a>
          </swiper-slide>
        </swiper>
      </div>
    </v-container>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: '.swiper-pagination',
        },
        centerInsufficientSlides: true,
        // Default parameters for smallest screen
        slidesPerView: 1,
        spaceBetween: 10,
        autoHeight: true,
        // Responsive breakpoints
        breakpointsInverse: true,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          1440: {
            slidesPerView: 6,
            spaceBetween: 40,
          },
          1920: {
            slidesPerView: 7,
            spaceBetween: 40,
          },
        },
      },
      swiper2Option: {
        loop: true,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: '.swiper-pagination',
        },
        // Default parameters for smallest screen
        slidesPerView: 1,
        spaceBetween: 10,
        // Responsive breakpoints
        breakpointsInverse: true,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          // when window width is >= 480px
          500: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          // when window width is >= 768px
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          // when window width is >= 1024px
          1280: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
        },
      },
      swiperSlides: [1, 2, 3, 4, 5],
      sponsors: [],
      medias: [],
      api: `${process.env.APP_URL}/uploads/`,
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  mounted() {
    setInterval(() => {
      if (this.swiperSlides.length < 10) {
        this.swiperSlides.push(this.swiperSlides.length + 1);
      }
    }, 3000);
    this.fetchSponsors();
  },
  methods: {
    fetchSponsors() {
      this.axios({
        method: 'GET',
        url: `${process.env.APP_URL}/api/sponsors`,
      })
      .then(result => {
        this.sponsors = result.data
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
@import 'swiper/dist/css/swiper.css';
.partners--link {
  max-width: 140px;
  max-height: 80px;
  img {
    width: 140px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.ambasadros--image {
  width: 120px;
  float: left;
}
.sliders-container {
  background-color: #ffffff;
  opacity: 0.95;
}
.ambasadors--title {
  font-family: 'Fira Sans', sans-serif;
  font-size: 12px;
  padding-top: 15px;
}
@media only screen and (max-width: 1450px) {
  .ambasadors--title {
    padding-top: 10px;
  }
}
.ambasadors--name {
  font-family: 'Fira Sans', sans-serif;
  font-size: 12px;
  font-weight: 900;
  color: #275271;
  padding-bottom: 10px;
}
.ambasadors--position {
  font-family: 'Fira Sans', sans-serif;
  font-size: 10px;
}
.sparator-container {
  border-bottom: 1px solid black;
  margin: 10px 0px;
}
.sparator-rectangle {
  width: 115px;
  height: 8px;
  background-color: #275271;
}
.ambasadors--text-container {
  position: absolute;
  padding-left: 120px;
  padding-bottom: 5px;
  top: 0;
  margin: auto;
  min-height: 100%;
}
.ambasadors--link {
  text-decoration: none;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/SponsorsOnlySlider.vue